import React from 'react';
import PropTypes from 'prop-types';

import styles from './CreditBreakdownHeader.scss';

export default function CreditBreakdownHeader({ title, subtitle }) {
  return (
    <div className={styles.creditBreakdownHeader}>
      <h3 className={styles.title}>{title}</h3>
      <p className={styles.subtitle}>{subtitle}</p>
    </div>
  );
}

CreditBreakdownHeader.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
};
